import { useLocation } from 'react-router-dom';

export function useQueryParams() {
  return new URLSearchParams(useLocation().search);
}

export function getAllMetadataParams(searchParams) {
  const metadataEntries = [];

  Array.from(searchParams.entries()).forEach(([key, value]) => {
    if (key.startsWith('metadata')) {
      metadataEntries.push(`${key}=${encodeURIComponent(value)}`);
    }
  });

  return metadataEntries.length > 0 ? metadataEntries.join('&') : null;
}

export function addMetadataToUrl(url, metadataString) {
  if (!metadataString) return url;

  const separator = url.includes('?') ? '&' : '?';
  return `${url}${separator}${metadataString}`;
}

export function buildUrlWithParams(baseUrl, options = {}) {
  const { eventId, redirectUrl, metadata, metadataString } = options;
  const params = new URLSearchParams();

  if (eventId) {
    params.set('eventId', eventId);
  }

  if (redirectUrl) {
    params.set('redirectUrl', redirectUrl);
  }

  const separator = baseUrl.includes('?') ? '&' : '?';
  const urlWithParams = params.toString() ? `${baseUrl}${separator}${params.toString()}` : baseUrl;
  const finalMetadata = metadataString || metadata;

  return addMetadataToUrl(urlWithParams, finalMetadata);
}
